/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingIntelligenceEntityType =
    (typeof BuildingIntelligenceEntityType)[keyof typeof BuildingIntelligenceEntityType];

export const BuildingIntelligenceEntityType = {
    Person: 'Person',
    Organisation: 'Organisation',
    Asset: 'Asset',
} as const;
